module.exports = __webpack_public_path__ + "static/img/followChannelBg.3f8d8b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/followChannelBg.png
// module id = UwZj
// module chunks = 0